import { useMutation } from "@tanstack/react-query";
import httpRequest from "app/lib/axios/index";

interface Request {
  url: string;
  data: Record<string, any>;
}

const requestFun = async ({ url, data }: Request): Promise<any> => {
  const response = await httpRequest.patch(url, data);
  return response.data;
};

export const useUpdateApplicationStatus = () => {
  return useMutation<any, Error, Request>({
    mutationFn: requestFun,
  });
};
